import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { FilesAppStateService } from '../services/state.service';

@Directive({
  selector: '[appFilesAppContext]',
  standalone: true,
})
export class FilesAppContextDirective extends AppContextDirective {
  static readonly providers = [...BaseAppStateService.provideAs(FilesAppStateService)];

  protected getProviders(): Provider[] {
    return FilesAppContextDirective.providers;
  }
}
